<template>
    <div class="rareInfo">
      <Search :title="name">
        <div class="conclusion-desc-box">
          <p class="conclusion-desc high" >携带</p>

          <ExpandableText :text="result"></ExpandableText>
        </div>

        <div class="box">
          <van-tabs v-model="activeTab">
            <van-tab title="关注基因">
              <GeneList isshow="rare" :data="gene_list"></GeneList>
            </van-tab>
            <van-tab title="参考文献">
              <Paper :data="paper" :fake="fake_gene" :single="single"></Paper>
            </van-tab>
          </van-tabs>
        </div>

        <div class="disease-content">
          <ExpandableText icon="icontouxiang" color="red" title="疾病概述" :text="desc"></ExpandableText>
          <ExpandableText icon="iconyao" color="purple" title="临床特征" :text="clinical"></ExpandableText>
          <ExpandableText icon="iconzhenduanbaogao" color="orange" title="诊断依据" :text="diagnosis"></ExpandableText>
          <ExpandableText icon="iconjibing-zhiliao" color="green" title="治疗方案" :text="treatment"></ExpandableText>
        </div>

        <Pagination url="rareInfo" :id="id"></Pagination>
      </Search>
    </div>
</template>

<script>
import Search from '@/components/Search'
import ExpandableText from '@/components/ExpandableText'
import GeneList from '@/components/GeneList'
import Paper from '@/components/Paper'
import Pagination from '@/components/Pagination'
export default {
  name: 'rareInfo',
  data () {
    return {
      activeTab: '',
      id: this.$route.params.id,
      name: '', // 可知罕见病名称
      gene: '', // 对应的单基因病检测基因
      result: '', // 检测结论
      gene_list: [], // 基因列表
      desc: '', // 可知罕见病介绍
      clinical: '', // 临床特征
      diagnosis: '', // 诊断依据
      treatment: '', // 治疗方案
      paper: [
            'Richards S , Aziz N , Bale S , et al. Standards and guidelines for the interpretation of sequence variants: a joint consensus recommendation of the American College of Medical Genetics and Genomics and the Association for Molecular Pathology[J]. Genetics in Medicine, 2015, 17(5):405-423.',
           ' Hamosh A , Scott A F , Amberger J S , et al. Online Mendelian Inheritance in Man (OMIM), a knowledgebase of human genes and genetic disorders[J]. Nucleic Acids Research, 2005, 33(1):514-7.',
            'Harrison S M , Riggs E R , Maglott D R , et al. Using ClinVar as a Resource to Support Variant Interpretation[J]. Current protocols in human genetics / editorial board, Jonathan L. Haines. [et al.], 2016, 89:8.16.1-8.16.23.',
            'Rivera-Muñoz, Edgar A,  Milko L V ,  Harrison S M , et al. ClinGen Variant Curation Expert Panel experiences and standardized processes for disease and gene‐level specification of the ACMG/AMP guidelines for sequence variant interpretation[J]. Human Mutation, 2018, 39(11):1614-1622.',
            '检测位点严格遵守美国医学遗传学与基因组学学会（ACMG）遗传变异分类标准与指南以及临床基因组资源 (ClinGen)疾病变异管理专家小组(VCEP)指南进行判读，并以OMIM数据库和ClinVar数据库等国际权威数据库内容作为证据来源。',
            '由于基因组结构复杂性及检测方法的局限性，因此，单基因病携带项相关基因可能存在有关变异未被发现或低覆盖区域变异无法检测的情况；对于单基因病携带项，可进行遗传咨询及一代测序验证。'
      ],
      single: '', // XY同源染色体判断结果
      fake_gene: '' // 假基因
    }
  },
  methods: {
    getRareDetails () {
      this.util.get(this.api.rare_details + '?id=' + this.id, '', (success) => {
        this.name = success.details.name
        this.result = success.details.result
        this.gene_list = success.details.gene_list
        this.desc = success.details.desc
        this.clinical = success.details.clinical
        this.diagnosis = success.details.diagnosis
        this.treatment = success.details.treatment
        if (success.details.fake_gene) {
          this.fake_gene = success.details.fake_gene
        }
        if (success.details.single) {
          this.single = success.details.single
        }
      })
    }
  },
  mounted () {
    this.getRareDetails()
  },
  watch: {
    '$route' (to) {
      this.id = parseInt(to.params.id)
      this.getRareDetails()
    }
  },
  components: {
    Search,
    ExpandableText,
    GeneList,
    Paper,
    Pagination
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
</style>



// WEBPACK FOOTER //
// src/views/rare/rareInfo.vue